<template>
  <div>
    <button @click="btn">点击我判断，传值</button>
  </div>
</template>

<script>
import androidOrIos from './androidOrIos.js' // 自己的文件位置引入
export default {
  data(){
    return{

    }
  },
  mixins: [androidOrIos],
  methods:{
    //  开始=============================================
    btn() {
      var title = '我是标题'
      var message = '我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容'
      //安卓手机-iOS-pc判断开始
      if (this.isMobile_pc()) {
        if (
            this.is_andriod_ios().iPhone ||
            this.is_andriod_ios().iPad ||
            this.is_andriod_ios().ios
        ) {
          // ios内容
          console.log('ios');
          // 下面是传递值到苹果手机 showPopupIos 该调用方法名与苹果工程师沟通一至
          window.webkit.messageHandlers.showPopupIos.postMessage({
            name: title,
            content: message
          });
        }
        if (this.is_andriod_ios().android) {
          // 安卓内容
          console.log('android');
          // 下面是传递值到安卓手机，showPopupAndroid 该调用方法名与安卓工程师沟通一至
          //AndroidJs.showPopupAndroid(title, message)
        }
      } else {
        // pc端内容
        console.log('pc');
        alert('我是pc弹出')
      }
    },
    //  结束=============================================
  }
}
</script>
